"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusSelectOptions = exports.statusOptions = exports.rowsPerPageOptions = exports.meterTypeOptions = exports.importPreviewColumns = exports.columns = exports.captureMethodOptions = void 0;
var columns = [
    { name: "METER ID", uid: "meterId" },
    { name: "TYPE", uid: "meterType" },
    { name: "BUILDING", uid: "buildingName" },
    { name: "AREA (UNIT)", uid: "unitName" },
    { name: "PREVIOUS", uid: "previousReading" },
    { name: "CURRENT", uid: "currentReading" },
    { name: "CONSUMPTION", uid: "consumption" },
    { name: "PERIOD", uid: "billingPeriod" },
    { name: "METHOD", uid: "captureMethod" },
    { name: "STATUS", uid: "status" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
var statusOptions = [
    { key: "all", label: "All Statuses" },
    { key: "Pending", label: "Pending" },
    { key: "Approved", label: "Approved" },
    { key: "Disputed", label: "Disputed" },
    { key: "Flagged", label: "Flagged" },
];
exports.statusOptions = statusOptions;
var captureMethodOptions = [
    { key: "all", label: "All Methods" },
    { key: "Manual", label: "Manual" },
    { key: "Import", label: "Import" },
];
exports.captureMethodOptions = captureMethodOptions;
var meterTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "Power", label: "Power" },
    { key: "Water", label: "Water" },
];
exports.meterTypeOptions = meterTypeOptions;
var rowsPerPageOptions = [
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var importPreviewColumns = [
    { name: "ROW", uid: "rowNumber" },
    { name: "STATUS", uid: "status" },
    { name: "METER ID", uid: "meterId" },
    { name: "TYPE", uid: "meterType" },
    { name: "DATE", uid: "readingDate" },
    { name: "PREVIOUS", uid: "previousReading" },
    { name: "CURRENT", uid: "currentReading" },
    { name: "CONSUMPTION", uid: "consumption" },
    { name: "NOTES", uid: "notes" },
];
exports.importPreviewColumns = importPreviewColumns;
var statusSelectOptions = [
    { key: "Pending", label: "Pending" },
    { key: "Approved", label: "Approved" },
    { key: "Disputed", label: "Disputed" },
    { key: "Flagged", label: "Flagged" },
];
exports.statusSelectOptions = statusSelectOptions;
